var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Spinner',{attrs:{"fullscreen":true},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("Login successful!")]},proxy:true}])},[_vm._v("\n    We are redirecting to your Dashboard for Autonomous System Health\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }